export const PAYMENT_METHODS = {
  bank: 'bank',
  card: 'card',
  giropay: 'giropay',
  sepa_debit: 'sepa_debit',
  bancontact: 'bancontact',
  blik: 'blik',
  eps: 'eps',
  fpx: 'fpx',
  ideal: 'ideal',
  p24: 'p24',
  sofort: 'sofort',
  revolut_ob: 'revolut_ob',
};

export const PAYMENT_STATE = {
  initial: 'initial',
  settled: 'settled',
  failed: 'failed',
  waiting_for_3ds_response: 'waiting_for_3ds_response',
};